import { State, Action } from './types';

const mainReducer = (state: State, action: Action) => {
    switch (action.type) {
        case 'searchRequest': {
            return { ...state, loading: true, formTemplateData: {} };
        }
        case 'searchSuccess': {
            return { ...state, loading: false, hasErrored: false, formTemplateData: action.data };
        }
        case 'submitRequest': {
            return { ...state, loading: true };
        }
        case 'submitSuccess': {
            return { ...state, loading: false, hasErrored: false, options: action.data };
        }
        case 'errored': {
            return { ...state, loading: false, hasErrored: true, error: action.error };
        }
        case 'fetchFormRequest': {
            return { ...state, loading: true, hasErrored: false, error: '', formInstanceData: {} };
        }
        case 'fetchFormSuccess': {
            // we order the fields by ordinal
            const orderedFields = action.data.fields.sort((a, b) =>
                a.ordinal > b.ordinal ? 1 : -1,
            );
            return {
                ...state,
                loading: false,
                formInstanceData: { ...action.data, fields: orderedFields },
            };
        }
        case 'putFormRequest': {
            //find and update the field that has the field
            //@ts-ignore
            const newFields = state.formInstanceData.fields.map((item) =>
                item.fieldId === action.data.fieldId
                    ? { ...item, value: action.data.value }
                    : { ...item },
            );

            return {
                ...state,
                hasErrored: false,
                error: '',
                posting: true,
                //@ts-ignore
                prevFields: state.formInstanceData?.fields,
                formInstanceData: {
                    ...state.formInstanceData,
                    fields: newFields,
                },
            };
        }
        case 'putFormSuccess': {
            //find and update the field that has the field
            //@ts-ignore
            const newFields = state.formInstanceData.fields.map((item) => {
                if (item.fieldId === action.data.fieldId) {
                    item.value = action.data.value;
                }
                return item;
            });

            return {
                ...state,
                posting: false,
                formInstanceData: {
                    ...state.formInstanceData,
                    fields: newFields,
                },
            };
        }
        case 'putFormError': {
            return {
                ...state,
                posting: false,
                formInstanceData: {
                    ...state.formInstanceData,
                    fields: state.prevFields,
                },
            };
        }
        case 'submitFormRequest': {
            return { ...state, hasErrored: false, error: '' };
        }
        case 'submitFormSuccess': {
            return {
                ...state,
                hasErrored: false,
                error: '',
                formInstanceData: {
                    ...state.formInstanceData,
                    status: 2,
                },
            };
        }
        case 'submitFormError': {
            return { ...state, hasErrored: false, error: '' };
        }
        case 'fetchCountriesRequest': {
            return { ...state, loadingCountry: true };
        }
        case 'fetchCountriesSuccess': {
            return {
                ...state,
                countryList: action.data,
                error: '',
                hasErrored: false,
                loadingCountry: false,
            };
        }
        case 'putSelectedCountry': {
            return { ...state, selectedCountry: action.data };
        }
    }
};
export default mainReducer;
